"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

require("core-js/modules/es6.function.name");

var _objectSpread4 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

require("./CategoryNavbarElement.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helperUtil = require("./../common/util/helperUtil");

var _constants = require("../constants");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var CategoryNavbarElement = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CategoryNavbarElement, _React$Component);

  var _super = _createSuper2(CategoryNavbarElement);

  function CategoryNavbarElement(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CategoryNavbarElement);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resolveUrl", function (url) {
      if ((0, _helperUtil.isAbsolutePath)(url)) {
        return url;
      }

      return (0, _helperUtil.getDomainUrl)(_this.props.brandType) + url;
    });
    _this.state = {
      expandMore: false
    };
    return _this;
  }

  (0, _createClass2.default)(CategoryNavbarElement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          element = _this$props.element,
          attr = _this$props.attr,
          isMobile = _this$props.isMobile;

      if (!element) {
        return null;
      }

      var Icon = element && element.icon;
      var elementColorStyle = element && element.color ? {
        color: element.color
      } : {};
      return _react.default.createElement("div", {
        className: "navbar-element-container ".concat(this.props.className || "")
      }, _react.default.createElement("span", {
        className: "newCategoryBadge ".concat(element.newCategoryTagEnabled ? '' : 'new-category-badge-hide')
      }, "New"), (0, _objectSpread4.default)({}, attr).role === 'button' || (0, _objectSpread4.default)({}, attr).role === 'tab' ? _react.default.createElement("a", this.props.attr, _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "cat-item-text",
        style: elementColorStyle
      }, isMobile && element.mobileName ? element.mobileName : element.name), Icon && _react.default.createElement(Icon, {
        className: "icon "
      }))) : _react.default.createElement("a", (0, _extends2.default)({}, this.props.attr, {
        className: element.newCategoryTagEnabled ? "new-active" : '',
        onClick: function onClick() {
          if (typeof window !== 'undefined') {
            window.location.href = _this2.resolveUrl(element.url);
          }
        },
        onKeyPress: function onKeyPress(e) {
          _this2.props.onCategoryLinkKeyPressCB && _this2.props.onCategoryLinkKeyPressCB(e, _this2.resolveUrl(element.url));
        },
        onKeyDown: function onKeyDown(e) {
          _this2.props.onCategoryLinkDownCB && _this2.props.onCategoryLinkDownCB(e);
        }
      }), _react.default.createElement("span", {
        className: "cat-item-text",
        style: elementColorStyle
      }, isMobile && element.mobileName ? element.mobileName : element.name), Icon && _react.default.createElement(Icon, {
        className: "icon "
      })));
    }
  }]);
  return CategoryNavbarElement;
}(_react.default.Component);

exports.default = CategoryNavbarElement;
CategoryNavbarElement.propTypes = {
  element: _propTypes.default.object,
  attr: _propTypes.default.object,
  brandType: _propTypes.default.string,
  className: _propTypes.default.string,
  isMobile: _propTypes.default.bool
};
CategoryNavbarElement.defaultProps = {
  element: {},
  attr: {},
  brandType: _constants.BRANDS.SHUTTERFLY
};